
import React, { useState, useEffect } from "react";
import { C, RC, RF, apiFetch } from "../utils/api";

export default function Clientes({user, setForm, delCl}) {
  const [clientes,setClientes]=useState([]);
  const [search,setSearch]=useState("");
  useEffect(()=>{ apiFetch("/clientes.php").then(d=>{if(d.success)setClientes(d.clientes);}); },[]);
  const filtered=clientes.filter(c=>!search||c.nombre.toLowerCase().includes(search.toLowerCase())||(c.cedula||"").includes(search));
  return (
    <div style={{height:"100%",overflowY:"auto",padding:"1rem"}}>
      <div style={{display:"flex",gap:8,marginBottom:14}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Buscar cliente..." style={{flex:1,padding:"8px 12px",borderRadius:8,border:"1px solid "+C.border,fontSize:14}}/>
        {RF.includes(user.rol) && <button onClick={()=>setForm({tipo:"cliente"})} style={{padding:"8px 16px",background:C.accent,color:C.white,border:"none",borderRadius:8,fontSize:14,cursor:"pointer"}}>+ Nuevo</button>}
      </div>
      {filtered.length===0 && <p style={{color:C.muted,textAlign:"center",padding:"2rem 0"}}>No hay clientes</p>}
      {filtered.map(c=>(
        <div key={c.id} style={{background:C.white,borderRadius:10,padding:"12px",marginBottom:10,border:"1px solid "+C.border}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
            <div style={{flex:1}}>
              <p style={{margin:"0 0 4px",fontWeight:600,fontSize:14}}>{c.nombre}</p>
              <p style={{margin:"0 0 2px",fontSize:12,color:C.muted}}>{c.cedula} - {c.telefono}</p>
              <p style={{margin:"0 0 4px",fontSize:12,color:C.muted}}>{c.nap_nombre?"NAP: "+c.nap_nombre+" - Puerto "+c.puerto:"Sin NAP asignada"}</p>
              <span style={{fontSize:11,padding:"2px 8px",borderRadius:99,background:c.estado==="activo"?"#D1FAE5":"#FEE2E2",color:c.estado==="activo"?"#065F46":"#991B1B"}}>{c.estado}</span>
            </div>
            <div style={{display:"flex",gap:6,marginLeft:8}}>
              {RF.includes(user.rol) && <button onClick={()=>setForm({tipo:"cliente",edit:c})} style={{padding:"4px 8px",background:"#1E7BBF",color:"#fff",border:"none",borderRadius:6,fontSize:11,cursor:"pointer"}}>Editar</button>}
              {RC.includes(user.rol) && <button onClick={()=>delCl(c.id)} style={{padding:"4px 8px",background:"#FEE2E2",color:"#991B1B",border:"none",borderRadius:6,fontSize:11,cursor:"pointer"}}>X</button>}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
